<template>
    <div class="field-themepicker">
        <ul class="field-themepicker__list">
            <li
                v-for="(themes__value, themes__key) in getThemes"
                v-bind:key="id + '_' + themes__key"
                class="field-themepicker__list-item"
            >
                <span
                    class="field-themepicker__num"
                    v-html="'#' + ('000' + themes__key).slice(-3)"
                ></span>
                <input
                    type="radio"
                    :id="id + '_' + themes__key"
                    v-model="simpleFieldModel"
                    :value="themes__key"
                    class="field-themepicker__input"
                />
                <label :for="id + '_' + themes__key" class="field-themepicker__label">
                    <span class="field-themepicker__pseudo-radio"></span>
                    <img
                        width="200"
                        class="field-themevariant"
                        ref="svginject"
                        v-bind:class="'field-themevariant--' + themes__value.id"
                        v-bind:src="
                            generateMediaUrl({
                                path: 'static/ui/themes/theme-' + themes__value.id + '.svg'
                            })
                        "
                        alt=""
                    />
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';
import SVGInject from '@iconfu/svg-inject';

export default {
    data() {
        return {
            id: pushid()
        };
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getThemes', 'generateMediaUrl'])
    },
    mounted() {
        SVGInject(this.$refs.svginject);
    },
    mixins: [SimpleFieldMixin],
    props: {}
};
</script>
